export function isDownloadFotosDisabled(item: {
  is_provisorio?: boolean;
  tem_carga_foto?: boolean | number;
}): boolean {
  const temCargaFoto = item.tem_carga_foto === true || Number(item.tem_carga_foto) === 1;

  return item.is_provisorio === true || !temCargaFoto;
}

export function isDownloadDadosDisabled(item: { tem_dados_variaveis?: boolean | number }): boolean {
  const temDadosVariaveis =
    item.tem_dados_variaveis === true || Number(item.tem_dados_variaveis) === 1;

  return !temDadosVariaveis;
}
